import api from "../../api";

export const STAFF_NOTIFICATION_ROLES = ["ROLE_USER", "ROLE_STAFF"] as const;

export type StaffNotificationItem = {
    id: number | string;
    title: string;
    text: string;
    createdAt: string;
    isRead: boolean;
    type?: "promo" | "system" | "booking" | "other";
};

export type StaffNotificationsResponse = {
    ok: boolean;
    items: StaffNotificationItem[];
    nextCursor: string | null;
    unreadCount?: number;
};

const IDP_ORIGIN = process.env.REACT_APP_IDP_ORIGIN || "";
const NOTIFICATIONS_PATH = `${IDP_ORIGIN}/api/client/notifications`;

function buildNotificationUrl(path?: string): string {
    if (!path) {
        return NOTIFICATIONS_PATH;
    }

    return `${NOTIFICATIONS_PATH}/${String(path).replace(/^\/+/, "")}`;
}

export function fetchStaffNotifications(limit: number, cursor?: string | null) {
    return api.post<StaffNotificationsResponse>(
        buildNotificationUrl(),
        {
            roles: STAFF_NOTIFICATION_ROLES,
            limit,
            cursor: cursor ?? undefined,
        },
        { withCredentials: true }
    );
}

export function markStaffNotificationRead(id: number | string) {
    return api.post(
        buildNotificationUrl(`${id}/read`),
        {},
        { withCredentials: true }
    );
}
